import Vue from 'vue'
import store from '../store/index'
import Router from 'vue-router'
import AuthLogin from '../pages/Auth/Login'
import Home from '../pages/Home/Layout'
import BlankIndex from '../components/BlankIndex/Layout'
import Catalog from '../pages/Catalog/Layout'
import Category from '../pages/Catalog/Category/Layout'
import AddCategory from '../pages/Catalog/Category/Add'
import EditCategory from '../pages/Catalog/Category/Edit'
import AddProduct from '../pages/Catalog/Category/Product/Add'
import EditProduct from '../pages/Catalog/Category/Product/Edit'
import NewsEvents from '../pages/SMM/NewsEvents/Layout'
import AddNewsEvents from '../pages/SMM/NewsEvents/Add'
import EditNewsEvents from '../pages/SMM/NewsEvents/Edit'
import Page from '../pages/SMM/Page/Layout'
import EditPage from '../pages/SMM/Page/Edit'
import Site from '../pages/Site/Layout'
import OrderBooking from '../pages/Order_Booking/Layout'
import Order from '../pages/Order_Booking/Order/Layout'
import OrderNew from '../pages/Order_Booking/Order/New/LayoutNew'
import OrderInProgress from '../pages/Order_Booking/Order/In_Progress/LayoutInProgress'
import OrderEnded from '../pages/Order_Booking/Order/Ended/LayoutEnded'
import EditOrder from '../pages/Order_Booking/Order/Edit'
import Booking from '../pages/Order_Booking/Booking/Layout'
import BookingNew from '../pages/Order_Booking/Booking/New/LayoutNew'
import BookingEnded from '../pages/Order_Booking/Booking/Ended/LayoutEnded'
import EditBooking from '../pages/Order_Booking/Booking/Edit'
import SMM from '../pages/SMM/Layout'
import PromoCode from '../pages/SMM/Loyalty/PromoCode/Layout'
import AddPromoCode from '../pages/SMM/Loyalty/PromoCode/Add'
import ViewPromoCode from '../pages/SMM/Loyalty/PromoCode/View'
import StockRegister from '../pages/SMM/Loyalty/StockRegister/Layout'
import AddStockRegister from '../pages/SMM/Loyalty/StockRegister/Add'
import EditStockRegister from '../pages/SMM/Loyalty/StockRegister/Edit'
import StockCatalog from '../pages/SMM/Loyalty/StockCatalog/Layout'
import AddStockCatalog from '../pages/SMM/Loyalty/StockCatalog/Add'
import EditStockCatalog from '../pages/SMM/Loyalty/StockCatalog/Edit'
import BirthdayBonus from '../pages/SMM/Loyalty/BirthdayBonus/Layout'
import EditProjectSettings from '../pages/SMM/Settings/Edit'
import Push from '../pages/SMM/Push/Layout'
import AddPush from '../pages/SMM/Push/Add'
import ViewPush from '../pages/SMM/Push/View'
import Review from '../pages/SMM/Review/Layout'
import AddReview from '../pages/SMM/Review/Add'
import EditReview from '../pages/SMM/Review/Edit'
import Customer from '../pages/SMM/Customer/Layout'
import EditCustomer from '../pages/SMM/Customer/Edit'
import CustomerTelegram from '../pages/SMM/CustomerTelegram/Layout'
import EditCustomerTelegram from '../pages/SMM/CustomerTelegram/Edit'
import Head from '../pages/Head/Layout'
import User from '../pages/Head/User/Layout'
import AddUser from '../pages/Head/User/Add'
import EditUser from '../pages/Head/User/Edit'
import StatBooking from '../pages/Head/Statistic/Booking'
import StatOrder from '../pages/Head/Statistic/Order'
import StatCustomer from '../pages/Head/Statistic/Customer'
import StatCustomerTelegram from '../pages/Head/Statistic/CustomerTelegram'
import StatProducts from '../pages/Head/Statistic/Products'
import StatLogs from '../pages/Head/Statistic/Logs'
import TgMessage from '../pages/SMM/Telegram/Layout'
import AddTgMessage from '../pages/SMM/Telegram/Add'
import EditTgMessage from '../pages/SMM/Telegram/Edit'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: AuthLogin,
            meta: { logged: true }
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { reqAuth: true }
        },
        {
            path: '/site',
            name: 'siteRoot',
            component: Site,
            meta: { reqAuth: true }
        },
        {
            path: '/catalog',
            component: Catalog,
            meta: { reqAuth: true },
            children: [
                {
                    path: '/',
                    name: 'blankIndexSEOSMM',
                    component: BlankIndex
                },
                {
                    path: 'category',
                    name: 'categoryRoot',
                    component: Category,
                    children: [
                        {
                            path: 'add',
                            name: 'addCategory',
                            component: AddCategory
                        },
                        {
                            path: 'edit/:categoryId',
                            name: 'editCategory',
                            component: EditCategory,
                            props: true
                        },
                        {
                            path: 'product/add',
                            name: 'addProduct',
                            component: AddProduct
                        },
                        {
                            path: 'product/edit',
                            name: 'editProduct',
                            component: EditProduct
                        }
                    ]
                }
            ]
        },
        {
            path: '/orderBooking',
            component: OrderBooking,
            meta: { reqAuth: true },
            children: [
                {
                    path: '/',
                    name: 'blankIndexOrderBooking',
                    component: BlankIndex
                },
                {
                    path: 'order',
                    name: 'ordersRoot',
                    component: Order,
                    children: [
                        {
                            path: 'new',
                            name: 'ordersNew',
                            component: OrderNew,
                            children: [
                                {
                                    path: 'edit/:orderId',
                                    name: 'editOrderForNew',
                                    component: EditOrder,
                                    props: true
                                }
                            ]
                        },
                        {
                            path: 'inProgress',
                            name: 'ordersInProgress',
                            component: OrderInProgress,
                            children: [
                                {
                                    path: 'edit/:orderId',
                                    name: 'editOrderForInProgress',
                                    component: EditOrder,
                                    props: true
                                }
                            ]
                        },
                        {
                            path: 'ended',
                            name: 'ordersEnded',
                            component: OrderEnded,
                            children: [
                                {
                                    path: 'edit/:orderId',
                                    name: 'editOrderForEnded',
                                    component: EditOrder,
                                    props: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'booking',
                    name: 'bookingRoot',
                    component: Booking,
                    children: [
                        {
                            path: 'new',
                            name: 'bookingNew',
                            component: BookingNew,
                            children: [
                                {
                                    path: 'edit/:bookingId',
                                    name: 'editBookingForNew',
                                    component: EditBooking,
                                    props: true
                                }
                            ]
                        },
                        {
                            path: 'ended',
                            name: 'bookingEnded',
                            component: BookingEnded,
                            children: [
                                {
                                    path: 'edit/:bookingId',
                                    name: 'editBookingForEnded',
                                    component: EditBooking,
                                    props: true
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/smm',
            component: SMM,
            meta: { reqAuth: true },
            children: [
                {
                    path: '/',
                    name: 'blankIndexPromo',
                    component: BlankIndex
                },
                {
                    path: 'promo_code',
                    name: 'promoCode',
                    component: PromoCode,
                    children: [
                        {
                            path: 'add',
                            name: 'addPromoCode',
                            component: AddPromoCode
                        },
                        {
                            path: 'view/:promoCodeId',
                            name: 'viewPromoCode',
                            component: ViewPromoCode,
                            props: true
                        }
                    ]
                },
                {
                    path: 'stock_register',
                    name: 'stockRegister',
                    component: StockRegister,
                    children: [
                        {
                            path: 'add',
                            name: 'addStockRegister',
                            component: AddStockRegister
                        },
                        {
                            path: 'edit/:stockRegId',
                            name: 'editStockRegister',
                            component: EditStockRegister,
                            props: true
                        }
                    ]
                },
                {
                    path: 'stock_catalog',
                    name: 'stockCatalog',
                    component: StockCatalog,
                    children: [
                        {
                            path: 'add',
                            name: 'addStockCatalog',
                            component: AddStockCatalog
                        },
                        {
                            path: 'edit/:stockCatalogId',
                            name: 'editStockCatalog',
                            component: EditStockCatalog,
                            props: true
                        }
                    ]
                },
                {
                    path: 'birthday_bonus',
                    name: 'birthdayBonus',
                    component: BirthdayBonus
                },
                {
                    path: 'project_settings',
                    name: 'projectSettings',
                    component: EditProjectSettings
                },
                {
                    path: 'news_events',
                    name: 'newsEventsRoot',
                    component: NewsEvents,
                    children: [
                        {
                            path: 'add',
                            name: 'addNews',
                            component: AddNewsEvents
                        },
                        {
                            path: 'edit/:newsEventId',
                            name: 'editNews',
                            component: EditNewsEvents,
                            props: true
                        }
                    ]
                },
                {
                    path: 'tg',
                    name: 'tgMessageRoot',
                    component: TgMessage,
                    children: [
                        {
                            path: 'add',
                            name: 'addTgMessage',
                            component: AddTgMessage
                        },
                        {
                            path: 'edit/:tgMessageId',
                            name: 'editTgMessage',
                            component: EditTgMessage,
                            props: true
                        }
                    ]
                },
                {
                    path: 'push',
                    name: 'pushRoot',
                    component: Push,
                    children: [
                        {
                            path: 'add',
                            name: 'addPush',
                            component: AddPush
                        },
                        {
                            path: 'view/:pushId',
                            name: 'viewPush',
                            component: ViewPush,
                            props: true
                        }
                    ]
                },
                {
                    path: 'page',
                    name: 'pageRoot',
                    component: Page,
                    children: [
                        {
                            path: 'edit/:pageSlug',
                            name: 'editPage',
                            component: EditPage,
                            props: true
                        }
                    ]
                },
                {
                    path: 'review',
                    name: 'reviewRoot',
                    component: Review,
                    children: [
                        {
                            path: 'add',
                            name: 'addReview',
                            component: AddReview
                        },
                        {
                            path: 'edit/:reviewId',
                            name: 'editReview',
                            component: EditReview,
                            props: true
                        }
                    ]
                },
                {
                    path: 'customer',
                    name: 'customerRoot',
                    component: Customer,
                    children: [
                        {
                            path: 'edit/:customerId',
                            name: 'editCustomer',
                            component: EditCustomer,
                            props: true
                        }
                    ]
                },
                {
                    path: 'customer_telegram',
                    name: 'customerTelegramRoot',
                    component: CustomerTelegram,
                    children: [
                        {
                            path: 'edit/:customerId',
                            name: 'editCustomerTelegram',
                            component: EditCustomerTelegram,
                            props: true
                        }
                    ]
                },
            ]
        },
        {
            path: '/head',
            component: Head,
            meta: { reqAuth: true },
            children: [
                {
                    path: '/',
                    name: 'headBlankIndex',
                    component: BlankIndex
                },
                {
                    path: 'user',
                    name: 'userRoot',
                    component: User,
                    children: [
                        {
                            path: 'add',
                            name: 'addUser',
                            component: AddUser
                        },
                        {
                            path: 'edit/:userId',
                            name: 'editUser',
                            component: EditUser,
                            props: true
                        }
                    ]
                },
                {
                    path: 'statistic/booking',
                    name: 'statBooking',
                    component: StatBooking
                },
                {
                    path: 'statistic/order',
                    name: 'statOrder',
                    component: StatOrder
                },
                {
                    path: 'statistic/customer',
                    name: 'statCustomer',
                    component: StatCustomer
                },
                {
                    path: 'statistic/products',
                    name: 'statisticProducts',
                    component: StatProducts
                },

                {
                    path: 'statistic/logs',
                    name: 'statisticLogs',
                    component: StatLogs
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.reqAuth)) {
        const token = JSON.parse(sessionStorage.getItem('token'))
        const user = JSON.parse(sessionStorage.getItem('user'))

        if (!user || (user && user.id === 0) || !token || (new Date().getTime() > token.expired_at)) {
            next({
                name: 'login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.logged)) {
        const token = JSON.parse(sessionStorage.getItem('token'))
        const user = JSON.parse(sessionStorage.getItem('user'))

        if ((user && user.id !== 0) && (new Date().getTime() < token.expired_at)) {
            next({
                name: 'home',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
